import ApplicationController from './application_controller.js'

export default class extends ApplicationController {
  static targets = ['row']

  hasValues(filters) {
    return Object.values(filters).some(
      (value) => value !== null && value !== undefined && value !== ''
    )
  }

  filter(event) {
    const filters = this.getFilters()
    this.rowTargets.forEach((row) => {
      const shouldShow = this.shouldShowRow(row, filters)
      if (this.hasValues(filters)) {
        row.style.display = shouldShow ? '' : 'none'
      } else {
        row.style.display = ''
      }
    })
  }

  shouldShowRow(row, filters) {
    const cells = Array.from(row.querySelectorAll('td'))
    const rowData = this.formatCellData(cells)

    const removeArraySuffix = (key) => key.replace(/\[\]$/, '')
    const checkFilters = ([key, value]) => {
      const formattedKey = removeArraySuffix(key)
      if (
        value !== '' &&
        Object.prototype.hasOwnProperty.call(rowData, formattedKey)
      ) {
        return Array.isArray(value)
          ? value.includes(rowData[formattedKey])
          : rowData[formattedKey] === value
      } else if (value === '') {
        return true
      }
    }

    return Object.entries(filters).every(checkFilters)
  }

  getFilters() {
    const form = this.element.querySelector('form')
    const formData = new FormData(form)
    const filters = {}
    for (const [name, value] of formData.entries()) {
      if (filters[name]) {
        if (!Array.isArray(filters[name])) {
          filters[name] = [filters[name]]
        }
        filters[name].push(value)
      } else {
        // Otherwise, set the filter value
        filters[name] = value
      }
    }
    return filters
  }

  getDate(value) {
    return new Date(value).toISOString().split('T')[0]
  }

  formatCellData(cells) {
    const rowData = {}
    cells.map((cell) => {
      const spans = cell.querySelectorAll('span[data-filter]')
      if (spans !== null) {
        spans.forEach((span) => {
          const key = span.dataset.filter
          let value = span.dataset.value
          if (key === 'date') {
            value = this.getDate(value)
          }
          rowData[key] = value
        })
      }
    })
    return rowData
  }
}
